export enum RoleModalNames {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    PERMISSIONS = 'PERMISSIONS',
}